import axios, {AxiosResponse} from 'axios'
import {ICurrencyModel} from './CurrencyModel'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const CURRENCY_CREATE_URL = `${API_URL}api/v1/definition/currency/create`
export const CURRENCY_GET_ALL_URL = `${API_URL}api/v1/definition/currency/all`
export const CURRENCY_DELETE_URL = `${API_URL}api/v1/definition/currency/delete/`
export const CURRENCY_UPDATE_URL = `${API_URL}api/v1/definition/currency/update/`
export const CURRENCY_GET_BY_ID_URL = `${API_URL}api/v1/definition/currency/getById/`

export function createCurrency(currencyData: ICurrencyModel) {
  return axios.post(CURRENCY_CREATE_URL, currencyData)
}

export function updateCurrency(currencyData: ICurrencyModel) {
  return axios.patch(CURRENCY_UPDATE_URL + currencyData.id, currencyData)
}

export async function loadCurrencys(
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<ICurrencyModel>>>> {
  return axios.get(CURRENCY_GET_ALL_URL, {
    params: {page, size, sort, order},
  })
}

export function deleteCurrency(currencyData: string) {
  return axios.delete(CURRENCY_DELETE_URL + currencyData)
}

export async function getCurrencyById(id: string): Promise<AxiosResponse<ApiResponse<ICurrencyModel>>> {
  return axios.get(CURRENCY_GET_BY_ID_URL+id);
}
